import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';

export default class Modalexpertbn extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",


   id_send:"",
   id_bn:"",
   filewordcomment_bn:null,

}

this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.getExpert = this.getExpert.bind(this);
this.toggle = this.toggle.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
;  this.props.selectex();
}


 componentDidMount() {
      const { id_send } = this.props.id_send
      console.log(id_send);
      this.setState({ id_send:this.props.id_send})
      this.setState({ id_bn:this.props.expert_id})
      setTimeout(() => {
        //ภายใน
         Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectExpert.php')
        .then(res => {
          console.log(res);
        //  this.setState({ bankname: res.data, loading: false })
          this.setState({ Expert: res.data})
        }) 

      }, 0);

  }

  getExpert() {
    setTimeout(() => {
    //  const { id_send } = this.props.id_send
     // this.setState({ id_send:this.props.id_send})
      //ภายใน
       Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectExpert.php')
      .then(res => {
        console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
        this.setState({ Expert: res.data})
      }) 

    }, 0);

}


  handleChange(event) {    this.setState({fileexpert: event.target.files[0]});  }
  handleChange2(event) {    this.setState({filewordcomment_bn: event.target.files[0]});  }


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("idExpert", this.state.idExpert);
      datafrm.append("idsend", this.state.id_send);
      datafrm.append("avatar", this.state.fileexpert);
      datafrm.append("avatar2", this.state.fileexpert2);
      
  Axios.post("https://edu.kpru.ac.th/conference/PHPAPI/uploadcomment1.php",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
    console.warn(res);
     console.log("response: ", res)
     if (res.data.length !== 0) {
      // this.showitem = true;
       console.log(res)
       console.log(res.data.length) 
    }else{
     // window.location.href = '/'
    }


    if (res.data.status = 'success999') {
      message.success("อัพโหลไฟล์สำเร็จ")
      this.toggle()
     // window.location.href = '/expert'
    }else{
      message.error("อัพโหลไฟล์ไม่สำเร็จ!")
    }
  })


//อัพเดทสถานะ
  Axios
  // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
    .post("https://edu.kpru.ac.th/conference/PHPAPI/updatestapat3.php",datafrm)
    .then(res => {
      console.log("response: ", res)
 
      if (res.data.length !== 0) {
       // this.showitem = true;
        console.log(res)
        console.log(res.data.length)
     }else{
      // window.location.href = '/'
     }
   })

}, 2000);

  //this.props.updateat();
  this.toggle()
  this.getExpert()

  }

  

    render() {
        

        return (
            <MDBContainer>
            <MDBBtn color="deep-purple" onClick={this.toggle}>อัพโหลดข้อเสนอ</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>{this.props.namearticla}{this.props.id_send}</MDBModalHeader>
              <MDBModalBody>
              <div>


              <p>อัพโหลดไฟล์แบบประเมิน .pdf</p>
                <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                        success="right"  name="file2" value={this.state.value} onChange={this.handleChange2} required/>

                      
            
              </div>

               <p className="orange-text">หมายเหตุ : ต้องอัพโหลดทั้ง 2 ไฟล์ระบบจึงจะสามารถบันทึกได้</p>
              </MDBModalBody>

             
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                {this.state.fileexpert == null || this.state.fileexpert2 == null ? <><MDBBtn color="primary" disabled >บันทึก</MDBBtn> </> :<>  <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn></> }
              
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}


